import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {MenuComponent} from '../assets/ts/components'
import {useThemeMode} from '../partials/layout/theme-mode/ThemeModeProvider'
import {Content} from './components/Content'
import {Footer} from './components/Footer'
import {ScrollTop} from './components/ScrollTop'
import {AsideDefault} from './components/aside/AsideDefault'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {Toolbar} from './components/toolbar/Toolbar'
import {PageDataProvider} from './core'

const MasterLayout = () => {
  const location = useLocation()
  const {mode} = useThemeMode()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key,mode])

  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root'>
        {/* begin::Page */}
        <div className='page d-flex flex-row flex-column-fluid'>
          <AsideDefault />
          {/* begin::Wrapper */}
          <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper' style={{paddingTop:'5rem'}}>
            <HeaderWrapper />

            {/* <Toolbar /> */}

            {/* begin::Content */}
            <div id='kt_content' className='content d-flex flex-column flex-column-fluid mt-7'>
              <Content>
                <Outlet />
              </Content>
            </div>
            {/* end::Content */}
            <Footer />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Page */}
      </div>

      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
